module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms12x"
    }
  }, [_c('hrms-search-box-table', {
    ref: "hrms12xIndex",
    attrs: {
      "data": _vm.index.table,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms12xIndex,
      "searchBoxAlias": "hrms12x",
      "listFields": _vm.listFields,
      "selectRowBool": false,
      "selectBtnDisp": true,
      "selectEvent": _vm.selectEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group-button"
  }, [_c('button', {
    ref: "sendmail",
    staticClass: "btn bg-blue",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hrms12x-popup-sendmail"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" " + _vm._s(_vm.btn_sendmail))])]), _vm._v(" "), _c('popup-send-mail', {
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "data": _vm.detail,
      "currentUser": _vm.dash.currentUser.username[_vm.dash.nowLang],
      "nowLang": _vm.dash.nowLang,
      "postSendmail": _vm.postSendmail,
      "empmail": _vm.empmail,
      "triggerIndexSelect": _vm.triggerIndexSelect,
      "triggerSuccess": _vm.triggerSuccess,
      "fileName": _vm.detail.attach,
      "receiveClearDetail": _vm.receiveClearDetail,
      "sendMailDisp": _vm.sendMailDisp,
      "notSendDisp": _vm.notSendDisp,
      "dataNotSend": _vm.dataNotSend,
      "columns": _vm.columns[_vm.dash.nowLang].notSend
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b26ca2e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms12x/component.vue
// module id = 3956
// module chunks = 1